import {useRef} from 'react';
import Pad from 'react-signature-canvas';
import { Box, Button, Stack, Typography } from '@mui/material';
import { HighlightOff } from '@mui/icons-material';
import { useState } from 'react';

export default function Canvas({onChange, label}){

    let signature = useRef({});

    const [clearable, setClearable] = useState(false)

    const clear = () => {
        signature.current.clear();
        return onChange(null);
    }

    const handleChange = () => {
        setClearable(true)

        if( signature.current.isEmpty() ){
            return onChange(null);
        }else{
            const dataURL = signature.current.toDataURL();
            const file = dataURLtoFile(dataURL);
            return onChange(file);
        }
    }

    return <Stack alignItems='start'>

        <Typography sx={{mb: 0.5}}>{label || 'Signez ici :'}</Typography>

        <Box
            onMouseUp={() => handleChange()}
            onMouseLeave={() => handleChange()}
            onTouchEnd={() => handleChange()}
            sx={{
                width: 'fit-content',
                border: 'solid 1px darkgrey',
                borderRadius: '5px',
                backgroundColor: 'rgb(250,250,250)',
                cursor: 'crosshair'
            }}
        >
            <Pad ref={signature} />
        </Box>

        <Button
            startIcon={<HighlightOff />} 
            onClick={clear}
            color='error'
            size='small'
            disabled={!clearable}
        >
            Effacer
        </Button>

    </Stack>
}


function dataURLtoFile(dataurl){
    let arr = dataurl.split(','); 
    let mime = arr[0].match(/:(.*?);/)[1];
    let bstr = atob(arr[1]);
    let n = bstr.length;
    let u8arr = new Uint8Array(n);
    while(n--){
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], 'signature.png', {type: mime});
}
